<template>
    <div class="verification-container">
        <div class="t1">{{$t('logout.VerifySended')}} <span>{{mobile}}</span></div>
        <div class="t2">{{$t('logout.Valid15M')}}</div>
        <div class="verification-code">
            <a-input
                v-model.trim="verificationCode"
                :maxLength="6"
                class="verification-code-input"
                :placeholder="$t('register.EnterVerificationCode')"
            />
            <template v-if="second>0">
                <span class="t3">{{second}}{{$t('common.Second')}}</span> <span class="t4">{{$t('register.Reacquire')}}</span>
            </template>
            <template v-else>
                <a-button class="t5" type="link" @click="reGetVerificationCode">{{$t('logout.Reacquire')}}</a-button>
            </template>

        </div>
        <BasicBtnGroup
            :showDef="false"
            @primeClick="confirm"
            class="verification-confirm-btn"
        >
            <span slot="primaryContent">{{$t('logout.ConfirmCancel')}}</span>
        </BasicBtnGroup>
    </div>
</template>
<script>
import { mapState } from 'vuex'
import BasicBtnGroup from '@/components/behavior/basic-btn-group/index.vue'

export default {
  name: 'CancelAccountVerification',
  components: {
    BasicBtnGroup,
  },
  data() {
    return {
      second: 59,
      verificationCode: undefined
    }
  },
  computed: {
    ...mapState(['userInfo']),
    mobile() {
      return this.userInfo.mobile.replace(/(\d{3})(\d{0,4})(\d{0,4})/, '$1 $2 $3')
    }
  },
  methods: {
    confirm() {
      if (!this.verificationCode) {
        return this.$message.warn(this.$t('logout.VerifyNotEmpty'))
      }
      if (this.verificationCode.length !== 6) {
        return this.$message.warn(this.$t('logout.IncorrectVerify'))
      }
      this.$emit('goSuccess', this.verificationCode)
    },
    reGetVerificationCode() {
      this.$emit('getVerificationCode')
      this.secondReduce()
    },
    secondReduce() {
      this.second = 59
      const timer = setInterval(() => {
        if (!(--this.second)) {
          clearInterval(timer)
        }
      }, 1000)
    }
  },
  mounted() {
    this.secondReduce()
  }
}
</script>
<style scoped lang="less">
.verification-container {
    position: relative;
    height: 100%;
    padding: 30px 56px 0;
    .t1 {
        font-weight: 400;
        color: #000;
        font-size: 16px;
        margin-bottom: 12px;
        span {
            font-size: 20px;
            color: #236CFF;
        }
    }
    .t2 {
        font-size: 16px;
        font-weight: 400;
        color: #6A6D73;
        margin-bottom: 40px;
    }
    .verification-code {
        .verification-code-input {
            width: 200px;
            height: 50px;
            background: #EFF3F8;
            box-shadow: inset 0px 0px 10px 0px rgba(151, 171, 199, 0.15);
            border-radius: 8px;
            border: 1px solid #236CFF;
            margin-right: 32px;
            font-size: 18px;
            font-weight: 500;
            color: #333;
            letter-spacing: 10px;
            &::placeholder {
                letter-spacing: normal;
            }
        }
        .t3 {
            font-size: 16px;
            color: #236CFF;
        }
        .t4 {
            font-size: 16px;
            color: #000;
        }
        .t5 {
            font-size: 18px;
            color: #236CFF;
            font-weight: 500;
        }
    }
    .verification-confirm-btn {
        position: absolute;
        right: 56px;
        bottom: 48px;
        ::v-deep .ant-btn {
            padding: 10px 16px;
        }
    }
}
</style>
